import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuex from 'vuex'
import store from './store/index'
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css';
import axios from 'axios'

Vue.prototype.$axios = axios;
Vue.prototype.$layer = layer(Vue);
Vue.use(Vuex)
Vue.config.productionTip = false
//章节页的路径
Vue.prototype.pathInfo={
  parentChapterLists:[],
  chapterList:[]
}



// 拦截器loading效果用到
Vue.http.interceptors.push((request, next) =>{ 
 
  let TOKEN=sessionStorage.getItem('STORAGE_TOKEN'); 
  
  if(TOKEN){ 
   
   request.headers.set('TOKEN',TOKEN); 
  } 
  store.commit('loading',true)

  next((response) => { 

 store.commit('loading',false)

    return response;
  }); 
 }); 
  function getServerConfig (Vue) {

    axios.get('./serverConfig.json?v='+new Date().getTime()).then(res => {
    
      var $config = res.data;
      // console.log('config',$config);
        //页面title
        Vue.prototype.globleTitle = $config.title;
        Vue.prototype.$version = $config.version;
        //设置title的函数
        Vue.prototype.setGlobleTitle = function(title){
          console.log('title',title);
          document.getElementById('titleId').innerHTML = title;
        }
        document.getElementById('titleId').innerHTML = $config.title;
        Vue.prototype.base_url = function (){
          return {
            img_baseurl:$config.baseurl,
            //baseurl:process.env.NODE_ENV=='development'?'':$config.baseurl,
            baseurl:$config.baseurl,
            wanZhanDaTuUrl:$config.wanZhanDaTuUrl,
            vrUrl:$config.vrUrl,
            logoImgUrl:$config.logoImgUrl,
            indexBg:$config.indexBg,
            logoLink:$config.logoLink,
            isShowChangJianWenTi:$config.isShowChangJianWenTi,
            isShowTips:$config.isShowTips,
            isShowZiXunGuanYuan:$config.isShowZiXunGuanYuan
          } 
        } 
     
      new Vue({
          render: h => h(App),
          router,
          store
        }).$mount('#app')
      
  })
}
 getServerConfig(Vue);


//https://fresh.lib.pku.edu.cn/
// "baseurl":"http://yndxrgjy.zxhnzq.com",
//"wanZhanDaTuUrl":"http://yndxrgjy.zxhnzq.com/web/default",